import React from "react";

import singleOverlay from "./../assets/AyurvedaAssets/images/single-overlay.png";
import NewsData from "../data/newsdata";
import youtubeVideos from "../data/YoutubeNews";

export default function Blog() {
  return (
    <>
      {/* Page Title */}
      <div className="prt-page-title-row style6">
        <div className="prt-page-title-row-inner">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="prt-page-title-row-heading">
                  <div className="page-title-heading">
                    <h2 className="title">Our latest stories</h2>
                  </div>
                  <div className="breadcrumb-wrapper">
                    <span>
                      <a title="Homepage" href="index-2.html">
                        Home
                      </a>
                    </span>
                    <span>Blog</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Site Main */}
      <div className="site-main">
        
        {/* 🔴 YouTube Videos Section (mobile horizontal, desktop grid) */}
        <section className="prt-row clearfix" style={{ padding: "40px 0" }}>
          <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 className="title mb-0">Customer Success Stories Scroll for more vidoes</h3>
              <a
                href="https://www.youtube.com/@Bharatdharacares"
                target="_blank"
                rel="noreferrer"
                className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor d-none d-md-inline-block"
              >
                Watch all videos →
              </a>
            </div>

            {/* mobile: horizontal scroll  |  md+: 3-col grid */}
            <div className="d-md-none" style={{ overflowX: "auto" }}>
              <div
                className="flex gap-4 pb-2"
                style={{ display: "flex", scrollSnapType: "x mandatory" }}
              >
                {youtubeVideos.map((video) => (
                  <a
                    key={video.title}
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white rounded-lg flex-shrink-0 transform hover:scale-95 transition-transform duration-300 snap-center w-[328px]"
                  >
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="rounded-lg mb-2 w-full h-[165px] object-contain"
                    />
                    <div className="font-semibold text-sm text-center line-clamp-2">
                      {video.title}
                    </div>
                  </a>
                ))}
              </div>
            </div>

            {/* desktop / tablet layout */}
            <div className="row d-none d-md-flex">
              {youtubeVideos.map((video) => (
                <div className="col-md-4 mb-4" key={video.title}>
                  <a
                    href={video.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white rounded-lg d-block h-100 p-0"
                    style={{ transition: "transform .3s" }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(.97)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  >
                    <img
                      src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`}
                      alt={video.title}
                      className="rounded-lg mb-3 w-100"
                      style={{ height: "200px", objectFit: "cover" }}
                    />
                    <div className="px-2 pb-3">
                      <div className="fw-semibold" style={{ fontSize: "15px" }}>
                        {video.title}
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>

            {/* mobile button */}
            <div className="mt-3 d-md-none text-center">
              <a
                href="https://www.youtube.com/@yourchannel"
                target="_blank"
                rel="noreferrer"
                className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
              >
                Watch all videos →
              </a>
            </div>
          </div>
        </section>
{/* Blog Section */}
        <section className="prt-row blog-section prt-blog-single clearfix">
          <div className="container">
            <div className="row">
              {NewsData.map((blog, index) => (
                <div className="col-lg-4 col-md-4 col-sm-12" key={index}>
                  <div className="featured-imagebox featured-imagebox-post style1">
                    <div className="featured-thumbnail">
                      <img
                        src={blog.img}
                        alt={blog.title}
                        style={{
                          width: "100%",
                          height: "auto", // let it grow
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="featured-content">
                      <div className="featured-content-inner">
                        <div className="post-header">
                          <div className="post-meta">
                            <span className="prt-meta-line category">
                              NEWS and Media
                            </span>
                            <span className="prt-meta-line time">
                              {blog.time}
                            </span>
                            <span className="prt-meta-line comment">
                              {blog.comments}
                            </span>
                          </div>
                          <div className="post-title featured-title">
                            <h3>
                              <a href="blog-single.html">{blog.title}</a>
                            </h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="prt-row prt-bg bg-base-grey prt-bgimage-yes bg-img1 cta-section position-relative animation clearfix">
          <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-grey"></div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="prt-single-image-overlay prt-blog-overlay">
                  <img
                    width="480"
                    height="491"
                    className="img-fluid"
                    src={singleOverlay}
                    alt="overlay"
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="section-title title-style-center_text">
                  <div className="title-header">
                    <h2 className="cta-title">Need a help</h2>
                    <h3 className="cta-titlepre">Get a free medical checkup</h3>
                  </div>
                  <div className="cta-bnt mt-40 fadeup-amin">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-skincolor"
                      href="contact-us.html"
                    >
                      +91-7060112355
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Info Section */}
        <section className="prt-row padding_zero-section prt-bg bg-base-skin info-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-md-12">
                <div className="prt-info-main-block">
                  <div className="info_btn mr-30 res-767-mb-15">
                    <a
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                      href="#"
                    >
                      COVID-19 resources
                    </a>
                  </div>
                  <div className="featured-icon-box icon-align-before-content style2">
                    <div className="featured-icon">
                      <div className="prt-icon prt-icon_element-onlytxt prt-icon_element-size-lg prt-icon_element-color-darkcolor">
                        <i className="flaticon-alert"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3>Get The Health package</h3>
                      </div>
                      <div className="featured-desc">
                        <p>
                          What you need to know about the 2019 - 2023 fly
                          season.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
